import { openCookieSettings, useCookieConsent } from '../tools/cookieConsent';
import '../style/cookieConsent.css';

export default function FormProtectionGate({ children, id = 'contact-form' }) {
  const allowed = useCookieConsent('captcha');
  return <div id={id} className="form-protection-gate">
    <fieldset disabled={!allowed} inert={!allowed} aria-hidden={!allowed || undefined} className={`form-protection-content${allowed ? '' : ' form-protection-disabled'}`}>{children}</fieldset>
    {!allowed && <div className="form-protection-overlay">
      <section className="form-protection-notice" aria-labelledby={`${id}-protection-title`}>
        <h3 id={`${id}-protection-title`}>Enable form protection</h3>
        <p>To use this form, enable <strong>Form protection</strong> in Cookie settings. Google reCAPTCHA helps protect against spam and automated abuse. Analytics can stay off.</p>
        <button type="button" className="cookie-button cookie-primary" onClick={openCookieSettings}>Cookie settings</button>
        <p>Prefer email? <a href="mailto:sales@baling.com">sales@baling.com</a></p>
      </section>
    </div>}
  </div>;
}
